import React from 'react';
import './SpouseProgram.css';
import Navbar from './Navbar';
import Footer from './Footer';

const spouseProgramData = [
  {
    day: 1,
    date: "Day 1 - December 9th, 2025 (1:30 PM - 5:30 PM)",
    places: [
      {
        id: 1,
        name: "Jawaharlal Nehru Planetarium",
        image: "https://assets-in.bmscdn.com/discovery-catalog/events/et00360323-pbhjgnbrdf-landscape.jpg", // Placeholder - user will replace
        // timing: "1:30 PM - 5:30 PM",
        description: "Dive into Bengaluru's scientific spirit at the Jawaharlal Nehru Planetarium. The immersive sky theatre brings constellations, planets, and cosmic phenomena to life through captivating digital projections. Interactive exhibits and the science park outside make the visit both informative and fun.",
        mustDo: [
          "Attend the popular 'Our Solar System' sky-theatre show",
          "Try hands-on experiments at the Science Park",
          "Catch the live science demonstration sessions",
          "Browse the astro-photography exhibits in the lobby"
        ]
      },
      {
        id: 2,
        name: "Vidhan Soudha",
        image: "https://media.istockphoto.com/id/92317684/photo/bangalore.jpg?s=612x612&w=0&k=20&c=uYLP4bmZl_rUJOfs4iLUJWlnLlh9T6Z0L8C12-KOKVY=", // Placeholder - user will replace
        // timing: "1:30 PM - 5:30 PM",
        description: "Walk around the imposing Vidhan Soudha, Karnataka's legislative building and one of India's largest neo-Dravidian structures. The granite monument dominates the skyline with 46-meter-tall domes, carved pillars, and sweeping staircases that make for dramatic photo backdrops.",
        mustDo: [
          "Capture photographs from the grand steps facing the statue of Dr. B. R. Ambedkar",
          "Learn about the building's history from local guides stationed outside",
          "Walk over to the neighbouring Karnataka High Court and Cubbon Park archway",
          "Visit in the evening to see the façade illuminated in tricolour lights"
        ]
      }
    ]
  },
  
  {
    day: 2,
    date: "Day 2 - December 10th, 2025 (9:00 AM - 1:00 PM)",
    places: [
      {
        id: 5,
        name: "Tipu Sultan Palace",
        image: "https://s7ap1.scene7.com/is/image/incredibleindia/tipu-sultans-summer-palace-bengaluru-karnataka-2-musthead-hero?qlt=82&ts=1742191834026", // Placeholder - user will replace
        // timing: "1:30 PM - 5:30 PM",
        description: "Explore Tipu Sultan's Summer Palace, an exquisite teakwood monument showcasing Indo-Islamic artistry. Built inside the Bangalore Fort complex, the palace features gracefully carved arches, frescoed walls, and balconies overlooking lush courtyards.",
        mustDo: [
          "Admire the floral and geometric murals along the corridors",
          "Visit the small museum that narrates the Anglo-Mysore wars",
          "Look for the Persian inscriptions describing Tipu as the 'Tiger of Mysore'",
          "Walk over to the nearby Bangalore Fort ramparts for panoramic views"
        ]
      },
      {
        id: 6,
        name: "ISKCON Temple",
        image: "https://holidayszone.in/images/sightseeing-places/bangalore/iskcon-temple-bangalore-entryfee-timings-tour-package-header.jpg", // Placeholder - user will replace
        // timing: "1:30 PM - 5:30 PM",
        description: "Conclude the program at the ISKCON Sri Radha Krishna Temple, a modern spiritual landmark perched on Hare Krishna Hill. The sprawling complex blends glass, marble, and gold-plated domes with serene prayer halls and cultural exhibits.",
        mustDo: [
          "Participate in the afternoon arati accompanied by kirtans",
          "Walk along the 208-step arcaded pathway depicting Krishna Leelas",
          "Visit the Vedic museum and Annamrita kitchen viewing gallery",
          "Relish prasadam at the Krsna Leela restaurant or Govinda's bakery",
          "Shop for handicrafts, devotional music, and books at the temple stores"
        ]
      }
    ]
  }
];

const PlaceCard = ({ place }) => (
  <div className="place-card">
    <div className="place-image-container">
      <img src={place.image} alt={place.name} className="place-image" />
      {/* <div className="place-timing-badge">{place.timing}</div> */}
    </div>
    <div className="place-content">
      <h3 className="place-name">{place.name}</h3>
      <p className="place-description">{place.description}</p>
      <div className="must-do-section">
        <h4 className="must-do-title">Must Things to Do:</h4>
        <ul className="must-do-list">
          {place.mustDo.map((item, idx) => (
            <li key={idx} className="must-do-item">
              <span className="must-do-icon">✓</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const DaySection = ({ dayData }) => (
  <div className="day-section">
    <div className="day-header">
      <h2 className="day-title">{dayData.date}</h2>
    </div>
    <div className="places-container">
      {dayData.places.map((place) => (
        <PlaceCard key={place.id} place={place} />
      ))}
    </div>
  </div>
);

const SpouseProgram = () => {
  return (
    <>
      <Navbar />
      <main className="spouse-program-container">
        <header className="spouse-program-header">
          <h1 className="spouse-program-title">Spouse Program - Tenative Schedule</h1>
          <p className="spouse-program-subtitle">
            A delightful 2-day program designed to showcase the rich culture, heritage, and modern charm of Bangalore, <strong>Meeting Point - Travel Desk, J.N. Tata Auditorium, IISc, Bengaluru</strong>
          </p>
          <p className="spouse-program-subtitle"> 
            NOTE- Spouse Program will be conducted only if we have more than 3 registration for spouse program.
          </p>
        </header>

        

        <div className="days-container">
          {spouseProgramData.map((dayData) => (
            <DaySection key={dayData.day} dayData={dayData} />
          ))}
        </div>

        <div className="program-footer-note">
          <p>
            <strong>Day 3 - December 11th, 2025 (6:00 AM)</strong><p>Visit to Ecological Park.</p> 
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SpouseProgram;

